import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'

const CardSelectDateTimePackageUX = (props: any) => {
    return(
      <div
        id="CardSelectDateTimePackageUX-div-0"
        style={{width: "100%"}}>
        <Form
          id="CardSelectDateTimePackageUX-Form-3">
          <FormGroup
            id="CardSelectDateTimePackageUX-FormGroup-4"
            inline={true}>
            <FormField
              className="required"
              id="CardSelectDateTimePackageUX-FormField-5"
              inline={true}
              width={4}>
              <label
                id="CardSelectDateTimePackageUX-label-6"
                style={{minWidth: "max-content"}}>
                แผนก
              </label>
              <Dropdown
                id="CardSelectDateTimePackageUX-Dropdown-7"
                onChange={props.onChangeDivision}
                options={props.allDivisionsOptions}
                search={true}
                selection={true}
                value={props.selectedAppDivision ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              inline={true}
              width={4}>
              <label>
                แพทย์
              </label>
              <div
                style={{width: "100%"}}>
                {props.doctorSearch}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardSelectDateTimePackageUX-div-2">
          {props.Calendar}
        </div>
      </div>
    )
}


export default CardSelectDateTimePackageUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Thu Jul 03 2025 17:05:15 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Calendar"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-div-2"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-Form-3"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-label-6"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSelectDateTimePackageUX-Dropdown-7"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.allDivisionsOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.selectedAppDivision ?? \"\""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearch"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 10,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardSelectDateTimePackageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
